<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.login"
          :label="$t('administration.user.login')"
          type="text"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">

        <v-combobox
          v-if="profilSelectItems"
          v-model="item.profil"
          :items="profilSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('administration.profil.profil')"
          item-text="name"
          item-value="id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.firstname"
          :label="$t('administration.user.firstname')"
          type="text"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.lastname"
          :label="$t('administration.user.lastname')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="item.enabled" row :label="$t('administration.user.enabled')">
          <v-radio
            :label="$t('global.true')"
            value="true"
          ></v-radio>
          <v-radio
            :label="$t('global.false')"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-row cols="12"></v-row>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'UserFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
      this.profilGetSelectItems();
  },

  computed: {
    ...mapFields('profil', {
      profilSelectItems: 'selectItems'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      profilGetSelectItems: 'profil/fetchSelectItems'
    }),
  }
};
</script>
